export default (assets, forceKeys) => {
  const findNestedAsset = (acc, curr) => {
    if (acc && acc[curr]) return acc[curr];
    return acc && typeof acc[curr] === "string" ? "" : null;
  };
  const getAsset = (key) => key.split(".").reduce(findNestedAsset, assets);
  return forceKeys
    ? (key) => key
    : (key, retNull) => {
        const translation = getAsset(key);
        if (translation) return translation;
        return translation === "" || retNull ? null : `[${key}]`;
      };
};
